import React from 'react';
import PropTypes from 'prop-types';
import { DiningIcon, DrinksIcon, Star } from '../Icons';
import { DeckIndicatorType, DeckType } from '../seatMapConstants';
import {
  Wrapper,
  CoachWrapper,
  Window,
  IconWrapper,
} from './DeckStyled';

const Deck = ({
  isDoubleDecker,
  deckFunction,
  isActive,
  isDisabled,
  handleClick,
  deckIndicator,
}) => {
  // width and height for star Icon
  const starDimensions = 9;
  const numberOfWindows = 4;

  return (
      <Wrapper
          isActive={isActive}
          isDisabled={isDisabled}
          isDoubleDecker={isDoubleDecker}
          deckFunction={deckFunction}
          role="button"
          aria-pressed="false"
          aria-disabled={isDisabled}
          tabIndex={0}
          onClick={handleClick}
      >
          {deckFunction === DeckType.PASSENGER && (
          <CoachWrapper isDoubleDecker={isDoubleDecker}>
              {Array.from(Array(numberOfWindows).keys()).map((element) => <Window key={element} isDoubleDecker={isDoubleDecker} />)}
              {deckIndicator === DeckIndicatorType.BUSINESS_1ERE && (
              <div className="stars">
                  <Star height={starDimensions} width={starDimensions} />
              </div>
              )}
          </CoachWrapper>
          )}

          {deckFunction === DeckType.BAR && (
          <IconWrapper>
              <DrinksIcon />
          </IconWrapper>
           )}
          {deckFunction === DeckType.DINING && (
          <IconWrapper>
              <DiningIcon />
          </IconWrapper>
          )}
      </Wrapper>
 );
};

Deck.propTypes = {
 isDoubleDecker: PropTypes.bool,
 deckFunction: PropTypes.any,
 isActive: PropTypes.bool,
 isDisabled: PropTypes.bool,
 handleClick: PropTypes.func,
 deckIndicator: PropTypes.any,
};

export default Deck;
